module.exports = __webpack_public_path__ + "front/img/27_2.ecacd4f6.png";